import type {IConfigLoader} from "header-bidding-client-base/modules/config/domain/iConfigLoader";
import {initGptHeaderBidding} from "../gptHeaderBiddingScript";
import {WindowConfigLoader} from "header-bidding-client-base/modules/config/infrastructure/windowConfigLoader";
import {
    EdPrebidJsBiddersLoader
} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/projects/ed/edPrebidJsBiddersLoader";

// Define dependencies
const configLoader: IConfigLoader = new WindowConfigLoader();
const prebidJSBiddersLoaderClass = EdPrebidJsBiddersLoader;
initGptHeaderBidding(configLoader, prebidJSBiddersLoaderClass);

